import { TextField } from 'mui-rff';
import React from 'react';

import { HelpOutlineOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { TooltipUnderline } from '@waypoint/react/atoms';

type Props = {
  name: string;
};
export default function HideSectionInput({ name }: Props) {
  return (
    <TextField
      fullWidth
      name={`${name}.sectionProps.hiddenCondition`}
      variant="standard"
      label="Hidden"
      placeholder="false"
      size="small"
      margin="normal"
      helperText={
        <>
          Example:{' '}
          <TooltipUnderline title="Enter the variable name directly (without double curly braces).">
            <code>{'price > 100'}</code>
          </TooltipUnderline>
          .
        </>
      }
      InputProps={{
        endAdornment: (
          <Tooltip title="Variable to dynamically control whether this block is hidden.">
            <span>
              <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
            </span>
          </Tooltip>
        ),
      }}
    />
  );
}
